import { API, axiosInstance } from "lib";

export const updateLrProcess = (data = {}) => {
  return axiosInstance
    .post(API.TRIP_SERVIES + '/apk_update_lr_process', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }
    
    });
};

export const podReceivedData = (data={}) => {
  return axiosInstance
    .post(API.TRIP_SERVIES + 'apk_pod_received' , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }
   
    });
};

export const podStatusUpdateData = (data={}) => {
  return axiosInstance
    .post(API.TRIP_SERVIES + 'apk_pod_update' , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }
   
    });
};

export const deletePodImage = (data={}) => {
  return axiosInstance
    .post(API.DELETE_POD_FILE , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }
   
    });
};

export const podUpdateDataService = (data={}) => {
  return axiosInstance
    .post(API.POD_LR_UPDATE , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }
   
    });
};